import { LogOut, MessageCircleQuestion, Settings } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { IgIconButton, IgTooltip } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLogout } from "@src/api/user-auths/logout";
import { StandardRoutes } from "@src/components/Utils/routes";
import { GENERAL_ROUTES } from "@src/routes/routes";
import { mpClickGetHelp } from "@src/utils/mixpanel";

export const IgPageTopBarActions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const isAdmin = useIsAdmin();
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IgTooltip title={"Need help? Contact support."}>
        <IgIconButton
          onClick={() => {
            mpClickGetHelp(location.pathname);
            void navigate(
              `${GENERAL_ROUTES.GetHelp}?ref=${encodeURIComponent(location.pathname)}`
            );
          }}
        >
          <MessageCircleQuestion size={16} />
        </IgIconButton>
      </IgTooltip>
      <IgTooltip
        title={
          <Stack alignItems="center">
            <span>Settings</span>
            {isAdmin && (
              <span style={{ color: theme.igPrimitives.gray["A100"] }}>
                Ctrl+S
              </span>
            )}
          </Stack>
        }
      >
        <IgIconButton
          onClick={() => {
            void navigate(StandardRoutes().settings.path);
          }}
        >
          <Settings size={16} />
        </IgIconButton>
      </IgTooltip>
      <IgTooltip title={"Log out"}>
        <IgIconButton
          onClick={() => {
            logout.mutate();
          }}
        >
          <LogOut size={16} />
        </IgIconButton>
      </IgTooltip>
    </Stack>
  );
};
